import React from 'react';

export default function AboutHeading() {
    return (
        <div className='flex justify-center'>
            <div className='text-center mt-12'>
                <h1 className='text-4xl font-bold m-9 pt-3'>ABOUT ME</h1>
                <div className="w-8 h-1.5 bg-purple mx-auto rounded-lg"></div>
                <p className='text-lg w-full sm:w-3/4 m-8 mx-auto'>Here you will find more information about me, 
                    what I do, and my current skills mostly in terms 
                    of programming and technology, and a little about my education.
                </p>
            </div>
        </div>
    );
}
